// eslint-disable-next-line import/prefer-default-export
export const NO_OWNER_ID = '00000000-0000-0000-0000-000000000000';
